/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getProfile,
  getBenefits,
  uploadBanner,
  uploadProfilePhoto,
} from '../../services';
import { changeDataProfile } from '../../store';
import { addDefaultSrc } from '../../helper/lib';
import { toast } from 'react-toastify';
import ProfileDesigner from './ProfileDesigner';
import ProfileVendor from './ProfileVendor';
import MicroModal from 'micromodal';
import SimpleModal from '../../organism/MicroModal/SimpleModal';
import CropperProfilePicture from '../../organism/Crop/CropperProfilePicture';
import CropperBanner from '../../organism/Crop/CropperBanner';
import 'react-easy-crop/react-easy-crop.css';

MicroModal.init();

const Profile = () => {
  const dispatch = useDispatch();
  const { dataProfile, mode } = useSelector((state) => state.global);
  const bannerRef = useRef(null);
  const bannerFileInput = useRef(null);
  const profilePhotoFileInput = useRef(null);
  const isEditProfile = true;
  const [isEditProfilePhoto, setIsEditProfilePhoto] = useState(false);
  const [bannerImage, setBannerImage] = useState('');
  const [bannerTemp, setBannerTemp] = useState('');
  const [bannerCropped, setBannerCropped] = useState('');
  const [bannerTemporary, setBannerTemporary] = useState('');
  const [profilePhotoImage, setProfilePhotoImage] = useState('');
  const [profilePhotoTemp, setProfilePhotoTemp] = useState('');
  const [profilePhotoCropped, setProfilePhotoCropped] = useState('');
  const [profilePhotoTemporary, setProfilePhotoTemporary] = useState('');
  const [isUploadingBanner, setIsUploadingBanner] = useState(false);
  const [isUploadingProfilePhoto, setIsUploadingProfilePhoto] = useState(false);
  const [benefits, setBenefits] = useState([]);

  const blobUrlToFile = async (blobUrl, fileName, mimeType) => {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    return new File([blob], fileName, { type: mimeType });
  };

  const checkImageSize = (file) => {
    const MAX_FILE_SIZE = 40960; // 40MB
    const fileSizeKiloBytes = file.size / 1024;

    if (fileSizeKiloBytes > MAX_FILE_SIZE) {
      toast.error('File size is more than 40MB');
      return false;
    }

    return true;
  };

  const readFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  };

  const onAttachBanner = async (e) => {
    e.preventDefault();

    if (e.target.files && e.target.files.length > 0) {
      const file = e?.target?.files[0];

      if (!checkImageSize(file)) {
        return;
      }

      if (
        file.type.includes('png') ||
        file.type.includes('jpg') ||
        file.type.includes('jpeg')
      ) {
        let imageDataUrl = await readFile(file);

        setBannerTemp(imageDataUrl);
        setBannerTemporary(file);
        handleCropBannerModal('open');
      } else {
        toast.error('Only PNG, JPG, and JPEG files are allowed');
        return;
      }
    }
  };

  const onAttachProfilePhoto = async (e) => {
    e.preventDefault();

    if (e.target.files && e.target.files.length > 0) {
      const file = e?.target?.files[0];

      if (!checkImageSize(file)) {
        return;
      }

      if (
        file.type.includes('png') ||
        file.type.includes('jpg') ||
        file.type.includes('jpeg')
      ) {
        let imageDataUrl = await readFile(file);

        setProfilePhotoTemp(imageDataUrl);
        setProfilePhotoTemporary(file);
        handleCropImageModal('open');
      } else {
        toast.error('Only PNG, JPG, and JPEG files are allowed');
        return;
      }
    }
  };

  const handleEditBanner = (e) => {
    e.preventDefault();
    bannerFileInput.current.click();
  };

  const handleEditProfilePhoto = (e) => {
    e.preventDefault();
    profilePhotoFileInput.current.click();
  };

  const uploadBannerToApi = async (bannerFile) => {
    setIsUploadingBanner(true);
    const loadingToast = toast.loading('Uploading...');
    try {
      const formData = new FormData();
      formData.append('image_banner', bannerFile);

      const response = await uploadBanner(formData);

      if (response.message === 'Success') {
        getUserData();
        setIsUploadingBanner(false);
        toast.update(loadingToast, {
          render: 'Banner image changed',
          type: 'success',
          isLoading: false,
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
        });
        handleCloseCropBanner();
      }
    } catch (error) {
      setIsUploadingBanner(false);
      toast.update(loadingToast, {
        render: error.response.data.message,
        type: 'error',
        isLoading: false,
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
  };

  const uploadProfilePhotoToApi = async (profilePhotoFile) => {
    setIsUploadingProfilePhoto(true);

    const loadingToast = toast.loading('Uploading...');

    try {
      const formData = new FormData();

      formData.append('photo', profilePhotoFile);
      const response = await uploadProfilePhoto(formData);

      if (response.message === 'Success') {
        getUserData();
        setIsUploadingProfilePhoto(false);
        toast.update(loadingToast, {
          render: 'Logo image changed',
          type: 'success',
          isLoading: false,
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
        });
        handleCloseCropImage();
      }
    } catch (error) {
      setIsUploadingProfilePhoto(false);
      toast.update(loadingToast, {
        render: error.response.data.message,
        type: 'error',
        isLoading: false,
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
  };

  const getUserData = async () => {
    try {
      const response = await getProfile();

      if (response.message === 'Success') {
        dispatch(changeDataProfile(response.data));
      }
    } catch (error) {
      console.log('error', error.response.data.message);
    }
  };

  const fetchBenefits = async () => {
    try {
      const response = await getBenefits();
      if (response.message === 'Success') {
        const newInputs = response?.data?.map((input) => ({
          ...input,
        }));
        setBenefits(newInputs);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const handleCropImageModal = (status) => {
    if (status === 'open') {
      MicroModal.show('profile-picture-modal');
      return;
    }
    MicroModal.close('profile-picture-modal');
  };

  const handleCropBannerModal = (status) => {
    if (status === 'open') {
      MicroModal.show('banner-modal');
      return;
    }
    MicroModal.close('banner-modal');
  };

  const handleCloseCropImage = () => {
    handleCropImageModal('close');
    setProfilePhotoTemp('');
    setProfilePhotoTemporary('');
    profilePhotoFileInput.current.value = '';
  };

  const handleCloseCropBanner = () => {
    handleCropBannerModal('close');
    setBannerTemp('');
    setBannerTemporary('');
    bannerFileInput.current.value = '';
  };

  const handleCroppedImage = async (data) => {
    setProfilePhotoCropped(data);

    const imageFile = await blobUrlToFile(
      data,
      profilePhotoTemporary.name,
      profilePhotoTemporary.type
    );

    uploadProfilePhotoToApi(imageFile);
  };

  const handleCroppedBanner = async (data) => {
    setBannerCropped(data);

    const imageFile = await blobUrlToFile(
      data,
      bannerTemporary.name,
      bannerTemporary.type
    );

    uploadBannerToApi(imageFile);
  };

  useEffect(() => {
    setBannerImage(
      dataProfile?.url_banner.length > 0 ? dataProfile?.url_banner : '#'
    );
    setProfilePhotoImage(
      dataProfile?.logo.length > 0 ? dataProfile?.logo : '/dist/img/logo.svg'
    );
  }, [dataProfile]);

  useEffect(() => {
    if (!dataProfile) {
      getUserData();
    }
  }, []);

  useEffect(() => {
    if (mode === 'designer') {
      fetchBenefits();
    }
  }, [mode]);

  return (
    <div className="tab-content" id="pills-tabContent">
      <SimpleModal id={'profile-picture-modal'}>
        <div>
          <CropperProfilePicture
            image={profilePhotoTemp}
            handleCroppedImage={handleCroppedImage}
            handleCancelCrop={handleCloseCropImage}
            uploadLoading={isUploadingProfilePhoto}
          />
        </div>
      </SimpleModal>

      <SimpleModal id={'banner-modal'}>
        <div>
          <CropperBanner
            image={bannerTemp}
            handleCroppedImage={handleCroppedBanner}
            handleCancelCrop={handleCloseCropBanner}
            uploadLoading={isUploadingBanner}
            clientHeight={bannerRef.current?.clientHeight}
            clientWidth={bannerRef.current?.clientWidth}
          />
        </div>
      </SimpleModal>

      {/* <!-- Profile --> */}
      <div
        className="tab-pane fade show active"
        id="pills-profile"
        role="tabpanel"
        aria-labelledby="pills-profile-tab"
      >
        <div>
          <div className="w-100 position-relative img-profile-wrapper">
            <div
              className="w-100 d-flex align-items-center justify-content-center rounded-lg overflow-hidden position-relative back-profile"
              style={{ border: '1px solid #e2e2e2' }}
            >
              <div
                ref={bannerRef}
                className="img-wrap w-100 h-100 object-fit-cover"
              >
                <img
                  alt="banner"
                  src={bannerCropped || bannerImage}
                  onError={addDefaultSrc}
                  className="object-fit-cover"
                />
              </div>

              <div className="btn-back-background">
                <input
                  accept="image/*"
                  type="file"
                  ref={bannerFileInput}
                  onChange={onAttachBanner}
                  className="d-none"
                />
                {!isUploadingBanner && (
                  <>
                    <button
                      className="btn btn-fill border d-flex justify-content-center align-items-center"
                      onClick={handleEditBanner}
                    >
                      <div className="img-wrap">
                        <img
                          alt=""
                          src="../dist/img/custom/camera.svg"
                          className="filter-white icon-2"
                        />
                      </div>
                      <div className="ms-2 d-none d-md-block">
                        Edit Cover Image
                      </div>
                    </button>
                  </>
                )}
                {isUploadingBanner && (
                  <button
                    className={`btn btn-line-gray border d-flex justify-content-center align-items-center ${
                      isUploadingBanner ? 'disabled' : ''
                    }`}
                    disabled={isUploadingBanner}
                  >
                    {!isUploadingBanner && (
                      <div className="img-wrap">
                        <img
                          alt=""
                          src="../dist/img/custom/ic-done.svg"
                          className=" icon-2"
                        />
                      </div>
                    )}
                    <div className="ms-2 d-none d-md-block">
                      {isUploadingBanner ? 'Uploading..' : 'Save Cover Image'}
                    </div>
                  </button>
                )}
              </div>
            </div>
            <div className="w-100 d-flex justify-content-center justify-content-md-start ps-md-5 img-profile">
              <div className="av-circle overflow-unset position-relative">
                <div
                  className="av-circle border-white border"
                  style={
                    isUploadingProfilePhoto ? { filter: 'opacity(0.5)' } : {}
                  }
                >
                  {!isEditProfilePhoto && (
                    <img
                      alt="user-pict"
                      src={profilePhotoCropped || profilePhotoImage}
                      onError={addDefaultSrc}
                    />
                  )}
                </div>

                {mode === 'designer' && (
                  <div
                    className="position-absolute btn-profile-background"
                    style={{ right: '9rem' }}
                  >
                    <div
                      className="img-wrap"
                      style={{ height: '32px', width: '32px' }}
                    >
                      {dataProfile?.group_name?.toLowerCase() ===
                        'platinum' && (
                        <img
                          src={`/dist/img/profile/group-platinum.png`}
                          alt="group-img"
                        />
                      )}
                      {dataProfile?.group_name?.toLowerCase() === 'elite' && (
                        <img
                          src={`/dist/img/profile/group-platinum.png`}
                          alt="group-img"
                        />
                      )}
                      {dataProfile?.group_name?.toLowerCase() ===
                        'celebrity' && (
                        <img
                          src={`/dist/img/profile/group-platinum.png`}
                          alt="group-img"
                        />
                      )}
                    </div>
                  </div>
                )}

                <div className="position-absolute btn-profile-background">
                  <input
                    accept="image/*"
                    type="file"
                    ref={profilePhotoFileInput}
                    onChange={onAttachProfilePhoto}
                    className="d-none"
                  />
                  {!isEditProfilePhoto && !isUploadingProfilePhoto && (
                    <button
                      className="btn btn-fill border rounded-circle icon-hw-b-1 p-0 d-flex align-items-center justify-content-center"
                      onClick={handleEditProfilePhoto}
                    >
                      <div className="img-wrap">
                        <img
                          alt=""
                          src="../dist/img/custom/camera.svg"
                          className="filter-white"
                        />
                      </div>
                    </button>
                  )}
                </div>
              </div>
            </div>
            {mode === 'designer' && (
              <div
                className="w-100 d-flex align-items-center justify-content-end rounded-lg overflow-hidden position-relative mt-2"
                style={{ gap: '5px' }}
              >
                {dataProfile?.group_name?.toLowerCase() === 'platinum' && (
                  <img
                    src={`/dist/img/profile/group-platinum.png`}
                    alt="group-img"
                    style={{ height: '24px', width: '24px' }}
                  />
                )}
                {dataProfile?.group_name?.toLowerCase() === 'elite' && (
                  <img
                    src={`/dist/img/profile/group-platinum.png`}
                    alt="group-img"
                    style={{ height: '24px', width: '24px' }}
                  />
                )}
                {dataProfile?.group_name?.toLowerCase() === 'celebrity' && (
                  <img
                    src={`/dist/img/profile/group-platinum.png`}
                    alt="group-img"
                    style={{ height: '24px', width: '24px' }}
                  />
                )}

                <span className="fs-5 fw-bold mb-0">
                  {dataProfile?.group_name}
                </span>
              </div>
            )}
          </div>

          {mode === 'designer' && dataProfile && (
            <ProfileDesigner
              dataProfile={dataProfile}
              isEditProfile={isEditProfile}
              benefits={benefits}
              getUserData={getUserData}
            />
          )}

          {mode !== 'designer' && dataProfile && (
            <ProfileVendor
              dataProfile={dataProfile}
              isEditProfile={isEditProfile}
              getUserData={getUserData}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
